import type { SelectOption } from './Select.types';

export function getSelectButtonText<T>({
  multiple,
  selectedOption,
  placeholder,
  values,
  options,
  renderTriggerLabel,
}: {
  multiple?: boolean;
  selectedOption?: SelectOption<T | null | undefined> | null;
  placeholder: string;
  values?: T[];
  options?: SelectOption<T | null | undefined>[];
  renderTriggerLabel?: (values: T[]) => React.ReactNode;
}): { text: React.ReactNode; isShowingPlaceholder?: boolean } {
  if (!multiple)
    return selectedOption?.value ? { text: selectedOption?.label } : { text: placeholder, isShowingPlaceholder: true };

  if (!values || values.length === 0) return { text: placeholder, isShowingPlaceholder: true };

  if (values.length === 1 && options) {
    const option = options.find((opt) => opt.value === values[0]);
    if (option?.label) return { text: option.label };
  }

  return { text: renderTriggerLabel?.(values) || `${values.length} selected` };
}
